import request from 'utils/request'

// 获取表格数据
export const getTableData = data => request().post('customer/file/page', data)

// 下载
export const download = id =>
  request().get(`customer/file/download/${id}`, { responseType: 'blob' })

// 下载模板
export const templateDownload = type =>
  request().get(`customer/file/template/download/${type}`, {
    responseType: 'blob',
  })

// 上传
export const upload = data =>
  request().post('customer/file/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
